module.exports = __webpack_public_path__ + "img/9788991124936.bde64e3b.jpg";